import { notify } from '@affine/component';
import { useEffect } from 'react';

import {
  backPressureNoticeContent,
  onBackPressure,
} from '../modules/cloud/services/back-pressure-notice';

/** Shows the back-pressure notice the request layer reports, app-wide. */
export function BackPressureNotice(): null {
  useEffect(
    () =>
      onBackPressure(retryAfterSeconds =>
        notify.info(backPressureNoticeContent(retryAfterSeconds))
      ),
    []
  );
  return null;
}
